import React from "react";
import styled from "@emotion/styled";
import { Text } from "styles/utility-components";

import { useMyFeedPageState } from "components/my_feed/useMyFeedPageState";
import Button from "components/ui/button/Button";
import { SavedViewType } from "lib/generated/app-api";
import { EventDataTypes, EventNames, useTracking } from "lib/tracking";

type TemplatesProps = {
  templates?: SavedViewType[];
  setIsViewDrawerOpen: (isOpen: boolean) => void;
};

function Templates({ templates, setIsViewDrawerOpen }: TemplatesProps) {
  const { logEvent } = useTracking();
  const { setSelectedView } = useMyFeedPageState();

  return (
    <TemplatesWrapper>
      <TemplatesListScroll>
        {templates?.map((view) => (
          <Button
            key={view.id}
            buttonType="tertiary"
            onClick={() => {
              setSelectedView(view.id, view.name, "Default view");
            }}
            blackText
            justifyContent="flex-start"
            fullWidth
          >
            <Text fontWeight="500">{view.name}</Text>
          </Button>
        ))}
      </TemplatesListScroll>
      <ViewAllButtonWrapper>
        <Button
          key={"all_views"}
          onClick={() => {
            setIsViewDrawerOpen(true);
            logEvent(EventNames.allViewsTableOpened, {
              "Data type": EventDataTypes.savedView,
            });
          }}
          buttonType="secondary"
          fullWidth
        >
          View all
        </Button>
      </ViewAllButtonWrapper>
    </TemplatesWrapper>
  );
}

const TemplatesWrapper = styled.div({
  display: "flex",
  paddingTop: 8,
  backgroundColor: "white",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
});

const TemplatesListScroll = styled.div({
  flex: 1,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

const ViewAllButtonWrapper = styled.div({
  display: "flex",
  width: "100%",
  flexShrink: 0,
});

export default Templates;
